import en_translation from '@/i18n/translations/en.json';
import jpn_translation from '@/i18n/translations/jpn.json';

import { LocaleEnum } from '@/shared/types/global/i18n.types.ts';

export default {
  [LocaleEnum.EN]: en_translation,
  [LocaleEnum.JPN]: jpn_translation,
};
